export default __webpack_public_path__ + "static/media/s2p2.78888266.jpg";